class StyledText extends Component {

    constructor(el) {
        super(el);
        this.peopleRows = document.querySelectorAll('.PeopleRow');
        this.initTabs();
    }

    makeTabButtons (tabs, activeRow) {
        const tabSwitcher = document.createElement('div');
        tabSwitcher.classList.add('PeopleRow-switcher');

        tabs.forEach((tabItem, i) => {
            const tabLabel = tabItem.querySelector('.PeopleTab-label').textContent;
            const tabLink = document.createElement('a');
            if (i === 0) {
                tabLink.classList.add('is-active');
            }

            tabLink.appendChild(document.createTextNode(tabLabel));

            tabLink.addEventListener('click', () => {
                tabs.forEach(elem => {
                   elem.classList.remove('is-active');
                });
                tabs[i].classList.add('is-active');
                tabSwitcher.querySelectorAll('a').forEach((elem) => {
                    elem.classList.remove('is-active');
                });
                tabLink.classList.add('is-active');
            });

            tabSwitcher.appendChild(tabLink);
        });

        activeRow.querySelector('.PeopleRow-titleTabs').appendChild(tabSwitcher);
    }

    initTabs() {
        this.peopleRows.forEach((row, i) => {
            const tabs = row.querySelectorAll('.PeopleTab');
            tabs[0].classList.add('is-active');
            if (tabs.length > 1) {
                row.classList.add('has-tabs');
                this.makeTabButtons(tabs, row);
            }
        });
    }
}